import { render, staticRenderFns } from "./Complaint.vue?vue&type=template&id=a15e7446&scoped=true"
import script from "./Complaint.vue?vue&type=script&lang=ts"
export * from "./Complaint.vue?vue&type=script&lang=ts"
import style0 from "./Complaint.vue?vue&type=style&index=0&id=a15e7446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15e7446",
  null
  
)

export default component.exports